import { ActionType } from "../assets/constants/constants";
import { BASE_URL } from "../services/urls";

export const globalReducer = (state: any, action: any) => {
  const baseUrl:string = BASE_URL
  if (baseUrl?.indexOf('dev') !== -1 ) {
    console.log("action ---", action, "----state----------", state);
  }
  switch (action.type) {
    case ActionType.INIT_APP:
      return {
        ...state,
        initApp: action.payload,
      };
    case ActionType.LOGIN:
      return {
        ...state,
        user: action.payload,
      };
    case ActionType.IS_AUTH:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case ActionType.SET_STEP:
      return {
        ...state,
        signUpStep: action.payload,
      };
    case ActionType.SET_SUBSCRIPTION:
      return {
        ...state,
        sllSubscriptionStatus: action.payload,
      };
    case ActionType.LOGOUT:
      return {
        ...state,
        user: false,
      };
    case ActionType.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ActionType.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ActionType.LOTTIE_ANIMATION:
      return {
        ...state,
        lottieAnimation: action.payload,
      };
    case ActionType.UPADTE_ROUTE:
      return {
        ...state,
        history: action.payload,
      };
    case ActionType.EU_ALM_USER_INFO:
      return {
        ...state,
        user: action.payload,
      };
    case ActionType.LIVE_QUATER_LP_DATA:
      return {
        ...state,
        liveQuarterData: action.payload,
      };
    case ActionType.CLEAR_CONTEXT:
      return {
        user: null,
        isAuthenticated: false,
        loading: false,
        token: "",
        signUpStep: 0,
        username: "",
        password: "",
        subscription: null,
        error: null,
        updateProfile: null,
        sllSubscriptionStatus: null,
        initApp: false,
        sessionTimeoutPopup: {
          visible: false,
          message: '',
          title: '',
        }
      };
    case ActionType.PROFILE_CHANGE:
      return {
        ...state,
        user: { ...state.user, avatarUrl: action.payload },
        loading: false,
      };
    case ActionType.ENROLLED_PROGRAM_DATA:
      return {
        ...state,
        enrolledProgramData: action.payload,
      };
    case ActionType.SET_ENROLLMENT:
      return {
        ...state,
        isEnrollmentOpen: action.payload,
      };
    case ActionType.SET_QUARTER_DETAIL:
      return {
        ...state,
        enrollmentData: action.payload.enrollmentData,
        quarterDeatil: action.payload.enrollmentData,
        isEnrollmentOpen: action.payload.isEnrollmentOpen,
      };
    case ActionType.LIBRARY_DATA:
      return {
        ...state,
        libraryData: { ...state.libraryData, ...action.payload },
      };
    case ActionType.SEARCH_LIBRARY_DATA: 
      return {
        ...state,
        searchLibraryData: {
          ...state.searchLibraryData,
          ...action.payload,
        },
      };
    case ActionType.VALIDATION_ERROR:
      return {
        ...state,
        validationError: action.payload,
      };
    case ActionType.UPDATE_USER_PROFILE_NAME:
      return {
        ...state,
        user: {
          ...state.user,
          fields: {
            fullName: action.payload.fullName,
            displayName: action.payload.displayName,
          },
          timeZoneCode: action.payload.timezone,
          name: action.payload.fullName,
        },
      };
    case ActionType.SET_CURRENT_USER_TIMEZONE:
      return {
        ...state,
        user: { ...state.user, timeZoneCode: action.payload },
      };
    case ActionType.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload.notifications,
        notificationCount: action.payload.notificationCount,
        isNext: action.payload.isNext,
      };
    case ActionType.NOTIFICATION_SETTING:
      return {
        ...state,
        settings: { notification: action.payload },
      };
    case ActionType.IS_SOCIAL_LOGIN:
      return {
        ...state,
        isSocialLogin: action.payload,
      };
    case ActionType.SET_CATELOG:
      return {
        ...state,
        catlogList: action.payload.catlogList,
        fundamenalCatlogId: action.payload.fundamenalCatlogId,
      };
    case ActionType.CONTENT_LOADING:
      return {
        ...state,
        contentLoading: action.payload,
      };
    case ActionType.ALERT_BOX:
      return {
        ...state,
        alertBox: {
          visible: action.payload.visible,
          type: action.payload.type,
          title: action.payload.title,
          message: action.payload.message,
        },
      };
    case ActionType.SESSION_TIMEOUT_POPUP:
      return {
        ...state,
        sessionTimeoutPopup: {
          visible: action.payload.visible,
          message: action.payload.message,
          title: action.payload.title,
        },
      };
    case ActionType.FUNDAMENTAL_PROGRAM_ID:
      return {
        ...state,
        fundamentalId: action.payload,
      };
    case ActionType.REFETCH_PROGRAM_DTATA:
      return {
        ...state,
        refetchProgramData: !state.refetchProgramData,
      };
    case ActionType.CHAT_BOT_STATE:
      return {
        ...state,
        chatBot: action.payload,
      };
    case ActionType.TRIAL_OVER:
      return {
        ...state,
        user: null,
        loading: false,
        subscription: null,
        error: null,
        updateProfile: null,
        sllSubscriptionStatus: null,
      };
    case ActionType.CUSTOM_LOGIN:
      return { ...state, loginDetail: action.payload, lottieAnimation: false };
    case ActionType.SET_DISABLE:
      return {
        ...state,
        isEnrolledDisable: action.payload,
      };
      case ActionType.SET_KEYWORD:
      return {
        ...state,
        keyword: action.payload,
      };
      case ActionType.SET_ENROLLED_PROGRAM:
      return {
        ...state,
        isEnrolledProgram: action.payload,
      };
      case ActionType.GLOBAL_CHATBOT_KEY:
        return {
          ...state,
          globalChatBotkey: action.payload,
        };
        case ActionType.GLOBAL_CHATBOT_KEY_LOGOUT:
        return {
          ...state,
          chainlit_chat_bot: action.payload,
        };
        case ActionType.CORPORATE_LOGIN:
          return { ...state, corporateDetails: action.payload, lottieAnimation: false };
    default:
      return state;
  }
};
